export interface IRecurringConflictItem {
  date: string;
  dayName: string;
  title: string;
  startTime: string;
  /** When the booked reservation itself ends. */
  endTime: string;
  /** Its service's buffer after `endTime`, still busy time for the employee. */
  bufferAfterMinutes?: number;
  conflictType: string;
}

/** A conflict's `dayName`, indexed by `Date.getDay()` (Sunday = 0). */
export const conflictDayNames = [
  "Неделя",
  "Понеделник",
  "Вторник",
  "Сряда",
  "Четвъртък",
  "Петък",
  "Събота",
];
